import { checkHasAccess } from "./checkHasAccess";
import { getCurrentActiveSidebarNav } from "./getCurrentActiveSidebarNav";

import { TBooleanRecord } from "types";
import { TAB_LIST, TAB_LIST_ACCESSRIGHT } from "components/Layout/constants";

export const getAllowedTabList = ({
  buAccessRight,
  isSuperAdmin,
  pathname,
}: {
  pathname: string;
  buAccessRight?: TBooleanRecord;
  communityAccessRight?: TBooleanRecord;
  isSuperAdmin?: boolean;
}) => {
  const currentNav = getCurrentActiveSidebarNav(pathname);
  let finalTabList: Record<string, Record<string, string>> = {};

  for (const navTabItem in TAB_LIST_ACCESSRIGHT) {
    const pathValue = TAB_LIST_ACCESSRIGHT[navTabItem][currentNav];

    // Continue to the next loop if pathvalue is not exist in the current active nav
    if (pathValue === undefined) continue;

    if (
      (Array.isArray(pathValue) && !pathValue?.length) ||
      pathValue === null ||
      (typeof pathValue === "string" && isSuperAdmin)
    ) {
      finalTabList = {
        ...finalTabList,
        [navTabItem]: {
          ...finalTabList?.[navTabItem],
          [currentNav]: TAB_LIST[navTabItem][currentNav],
        },
      };
      continue;
    }

    if (pathValue?.length) {
      const hasAccess = checkHasAccess(pathValue as number[], buAccessRight);

      if (hasAccess) {
        finalTabList = {
          ...finalTabList,
          [navTabItem]: {
            ...finalTabList?.[navTabItem],
            [currentNav]: TAB_LIST[navTabItem][currentNav],
          },
        };
      }
      continue;
    }
  }

  return finalTabList;
};
